import { type ReduxSelector } from 'store/store.types';
import { type ProviderSearchTerm, type FacilitySearchTerm } from 'schemas';
import { SEARCH_TERMS_SLICE_NAME } from '../slicesNames';
import { type SearchTermsState } from './searchTerms.types';

export const isLoading: ReduxSelector<boolean> = (state) =>
  state[SEARCH_TERMS_SLICE_NAME].isLoading;
export const error: ReduxSelector<string | null> = (state) => state[SEARCH_TERMS_SLICE_NAME].error;
export const nameMap: ReduxSelector<SearchTermsState['nameMap']> = (state) =>
  state[SEARCH_TERMS_SLICE_NAME].nameMap;

/** Returns the search term with the matching name, case insensitive */
export function byName(
  name: ProviderSearchTerm['searchTerm'] | FacilitySearchTerm['searchTerm'],
  isProviderSearch: boolean
): ReduxSelector<ProviderSearchTerm | FacilitySearchTerm | undefined> {
  return (state) => {
    const key = name.toLowerCase();
    const { provider, facility } = state[SEARCH_TERMS_SLICE_NAME].nameMap;
    return isProviderSearch ? provider[key] : facility[key];
  };
}
